import React from 'react';
import { ArrowUpIcon } from 'lucide-react';
import { event } from '../data/masterclass';
export function FinalCta() {
  return <section aria-labelledby="final-cta-heading" className="bg-ink-soft" data-id="element-41" data-mp="vghfhjugu3md">
      <div className="mx-auto flex w-full max-w-5xl flex-col items-center px-6 py-20 pb-32 text-center lg:py-24 lg:pb-32" data-id="element-42" data-mp="19f7e53wxobcu">
        <img src={event.logoUrl} alt="Meet the Eatmons" className="h-28 w-28 object-contain sm:h-32 sm:w-32" data-id="element-43" data-mp="15ckfok5rbs6o" />

        <h2 id="final-cta-heading" className="mt-10 font-display text-6xl font-bold uppercase leading-[0.95] text-gold sm:text-7xl lg:text-[7.5rem]" data-id="element-44" data-mp="1eebnpvnrsb3p">
          Built to
          <span className="block text-white" data-id="element-45" data-mp="1o43l0xn97ibv">carry more.™</span>
        </h2>

        <p className="mt-10 text-sm font-semibold uppercase tracking-[0.14em] text-gold-pale" data-id="element-46" data-mp="1o5y4e7ivn2du">
          {event.eventLine}
        </p>

        <a href="#pricing" className="group mt-10 inline-flex items-center gap-2 rounded-full border border-gold px-9 py-4 text-sm font-bold uppercase tracking-[0.12em] text-gold transition-[transform,background-color,color] duration-200 ease-out hover:bg-gold hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold active:scale-[0.98]" data-id="element-47" data-mp="1x51q7j9fhvw1">
          Choose your experience
          <ArrowUpIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:-translate-y-0.5" aria-hidden="true" data-id="element-48" data-mp="120ilx0hd9toz" />
        </a>

        <p className="mt-8 text-sm text-white/45" data-id="element-49" data-mp="1b1qkzkrpiyk4">
          Secure checkout · Replay included · Workbook included · Live Q&amp;A
        </p>
      </div>
    </section>;
}